<template>
	<div class="form-wrapper">
		<div id="form-container">
			<div>
				<div id="sq-card-number"></div>
				<div id="sq-expiration-date"></div>
				<div id="sq-cvv"></div>
				<div id="sq-postal-code"></div>
			</div>
		</div>
		<input type="hidden" id="card-nonce" name="nonce" />
	</div>
</template>

<script>
export default {
	name: "GuestCreditCardForm",
}
</script>

<style scoped>
iframe {
	margin: 0;
	padding: 0;
	border: 0;
}

fieldset {
	margin: 0;
	padding: 0;
	border: 0;
}

#form-container {
	margin-top: 15px;
}

.form-wrapper {
	position: relative;
}
</style>